// extracted by mini-css-extract-plugin
module.exports = {"resetPageContainer":"style_resetPageContainer__10aG9","formContainer":"style_formContainer__3Hhh3","invalidToken":"style_invalidToken__38cNG"};